import { render } from "./FilePdfIcon.vue?vue&type=template&id=3996aa52"
import script from "./FilePdfIcon.vue?vue&type=script&lang=js"
export * from "./FilePdfIcon.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__